import React from 'react';
import SpeedTest from './containers/SpeedTest';
import ThemeToggle from './components/ThemeToggle';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';

const AppContent: React.FC = () => {
  const { mode } = useTheme();
  const isLight = mode === 'light';

  return (
    <div className={`min-h-screen flex flex-col ${isLight ? 'bg-gray-50' : 'bg-black'}`}>
      <header className={`
        ${isLight 
          ? 'bg-white border-gray-200' 
          : 'bg-black border-green-500/30'
        } 
        border-b py-4
      `}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <h1 className={`
              text-2xl md:text-3xl font-mono font-bold
              ${isLight ? 'text-gray-900' : 'text-green-500'}
            `}>
              LTE Speed Test
            </h1>
            <ThemeToggle />
          </div>
        </div>
      </header>
      
      <main className="flex-1 container mx-auto px-4 py-8">
        <SpeedTest />
      </main>
      
      <footer className={`
        mt-auto border-t py-4
        ${isLight 
          ? 'border-gray-200' 
          : 'border-green-500/30'
        }
      `}>
        <div className="container mx-auto px-4">
          <div className={`
            flex flex-col md:flex-row justify-between items-center text-sm font-mono gap-2
            ${isLight ? 'text-gray-600' : 'text-green-500'}
          `}>
            <p>© {new Date().getFullYear()} LTE Speed Test</p>
            <a href="https://adr.im/" 
               target="_blank" 
               rel="noopener noreferrer" 
               className={`hover:underline ${isLight ? 'text-gray-500 hover:text-gray-700' : 'text-green-400 hover:text-green-300'}`}>
               Check your IP address
            </a>
            <p className={isLight ? 'text-gray-500' : 'text-green-400'}>lte.sh</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App; 